import BlockContent from '@sanity/block-content-to-react'
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Icon,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Switch,
  Upload,
} from 'antd'
import axios from 'axios'
import React, { Component, Fragment } from 'react'
import { Head, withSiteData } from 'react-static'
import styled from 'styled-components'
import Seperator from '../components/Seperator'
import { toNetlifyFormData } from '../utils'
import Geodata from '../utils/geodata'
import getSerializers from '../utils/sanitySerializers'

const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const CheckboxGroup = Checkbox.Group
const MonthPicker = DatePicker.MonthPicker
const FormItem = Form.Item
const Option = Select.Option

// not sure why this is here
const StOption = styled(Option)`
  color: ${p => p.theme.textTransBlack};
`

const StSelect = styled(Select)`
  &.ant-select,
  .ant-select-search__field {
    color: ${p => p.theme.textTransBlack};
  }
`

const TextArea = Input.TextArea

const hasErrors = fieldsError =>
  fieldsError &&
  Object.keys(fieldsError).some(f =>
    typeof fieldsError[f] === 'object'
      ? hasErrors(fieldsError[f])
      : fieldsError[f]
  )

const required = message => ({ required: true, message })

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 14 },
  },
}

const StForm = styled(Form)`
  label {
    white-space: normal;
  }
`

const ActionIcon = styled(Icon)`
  cursor: pointer;
  transition: all 0.3s;
  font-size: 24px;
  position: relative;
  top: 4px;

  &:hover {
    color: #dadada;
  }
`
const displayNone = { display: 'none' }
let popId = 0

const countryOptions = Object.keys(Geodata.countries)
  .sort((a, b) =>
    Geodata.countries[a].name.localeCompare(Geodata.countries[b].name)
  )
  .map(k => {
    const country = Geodata.countries[k]
    return (
      <StOption title={country.name} key={k}>
        {country.name}
      </StOption>
    )
  })

class CheckValueInput extends React.Component {
  constructor(props) {
    super(props)

    const value = props.value || {}
    this.state = {
      available: value.available || false,
      price: value.price || 0,
    }
  }

  componentWillReceiveProps(nextProps) {
    // Should be a controlled component.
    if (nextProps.value) {
      const value = nextProps.value
      this.setState(value)
    }
  }

  _handleSwitchChange = available => {
    if (!this.props.value) {
      this.setState({ available })
    }

    this._triggerChange({ available })
  }

  _handlePriceChange = price => {
    if (!this.props.value) {
      this.setState({ price })
    }

    this._triggerChange({ price })
  }

  _triggerChange = changedValue => {
    this.props.onChange &&
      this.props.onChange(Object.assign({}, this.state, changedValue))
  }

  render() {
    const { size } = this.props
    const state = this.state
    return (
      <Fragment>
        <Switch checked={state.available} onChange={this._handleSwitchChange} />
        <span className="ant-form-text" style={{ marginLeft: '2%' }}>
          Price:
        </span>
        <InputNumber
          min={0}
          max={999999}
          value={state.price}
          disabled={!state.available}
          size={size}
          onChange={this._handlePriceChange}
          style={{ marginLeft: '4px' }}
        />
      </Fragment>
    )
  }
}

class AddCompanyForm extends React.Component {
  state = { screenshots: [] }

  _removePop = k => {
    const { form } = this.props
    // can use data-binding to get
    const keys = form.getFieldValue('keys')
    // We need at least one passenger
    if (keys.length === 1) {
      return
    }

    // can use data-binding to set
    form.setFieldsValue({
      keys: keys.filter(key => key !== k),
    })
  }

  _addPop = () => {
    const { form } = this.props
    // can use data-binding to get
    const keys = form.getFieldValue('keys')
    popId++
    const nextKeys = keys.concat(popId)
    // can use data-binding to set
    // important! notify form to detect changes
    form.setFieldsValue({
      keys: nextKeys,
    })
  }

  _validateOnSubmit = e => {
    e.preventDefault()

    const form = this.props.form

    form.validateFieldsAndScroll((err, values) => {
      // TODO: check err object for errors
      console.log('Validating Values: ', values)

      if (hasErrors(err)) return false

      // change to actual file values
      values.logo = this.state.logoFile
      this.state.screenshots.forEach(
        (ss, i) => (values[`controlPanelScreenshot${i + 1}`] = ss) // `
      )
      delete values.controlPanelScreenshots
      delete values.keys

      if (!form.isFieldTouched('modsFeatuers')) {
        values.modsFeatures = ''
      }

      values.monthEstablished =
        values.monthEstablished && values.monthEstablished.toDate()

      values.summary = `${values.companyName} - ${values.email}`

      this.props.onSubmit &&
        this.props.onSubmit({
          values,
          callback: submitResult => this.setState({ ...submitResult }),
        })
    })
  }

  render() {
    const {
      form: {
        getFieldDecorator,
        getFieldsError,
        validateFields,
        setFieldsValue,
        getFieldValue,
      },
      onSubmit,
      ...props
    } = this.props

    const keys = getFieldValue('keys') || [popId]

    const pointsOfPresence = keys.map((k, index) => (
      <FormItem
        {...formItemLayout}
        label={index === 0 ? 'Server Locations' : ' '}
        colon={index === 0}
        required={false}
        key={k}
      >
        <Row gutter={20}>
          <Col span={7}>
            <FormItem>
              {getFieldDecorator(`locations[${k}][country]`, {
                // `
                rules: [required('Please select a country')],
              })(
                <StSelect
                  showSearch
                  name={`locations[${k}][country]`} // `
                  placeholder="Country"
                  optionFilterProp="title"
                >
                  {countryOptions}
                </StSelect>
              )}
            </FormItem>
          </Col>
          <Col span={13}>
            <FormItem>
              {getFieldDecorator(`locations[${k}][pops]`)(
                // `
                <StSelect
                  name={`locations[${k}][pops]`} // `
                  mode="tags"
                  onInputKeyDown={e => e.key === 'Enter' && e.preventDefault()}
                  notFoundContent="Type a City, State and press Enter"
                  // style={{ width: '100%' }}
                  placeholder='City, State (e.g. "London" or "New York, NY")'
                />
              )}
            </FormItem>
          </Col>

          {keys.length > 1 ? (
            <Col span={1}>
              <ActionIcon
                type="minus-circle-o"
                disabled={keys.length === 1}
                onClick={() => this._removePop(k)}
              />
            </Col>
          ) : null}

          {index === keys.length - 1 ? (
            <Col span={2} style={keys.length > 1 && { textAlign: 'center' }}>
              <ActionIcon type="plus-circle-o" onClick={() => this._addPop()} />
            </Col>
          ) : null}
        </Row>
      </FormItem>
    ))

    return (
      <StForm
        {...props}
        onSubmit={this._validateOnSubmit}
        method="POST"
        action="thank-you"
        hideRequiredMark
      >
        <FormItem>
          {getFieldDecorator('form-name', { initialValue: 'addCompany' })(
            <input type="hidden" name="form-name" />
          )}
        </FormItem>
        <div style={{ visibility: 'hidden', height: 0 }}>
          <FormItem>
            <label>
              Sneaky non human field
              {getFieldDecorator('hp', { initialValue: '' })(
                <input name="hp" />
              )}
            </label>
          </FormItem>
        </div>
        <FormItem {...formItemLayout} label="Company Name">
          {getFieldDecorator('companyName', {
            rules: [required('Please enter your company name')],
          })(<Input name="companyName" />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Company Website">
          {getFieldDecorator('homepageUrl', {
            rules: [
              {
                type: 'url',
                message:
                  'Invalid URL, please use the format https://example.com',
                required: 'Please enter your company website',
              },
            ],
          })(
            <Input name="homepageUrl" placeholder="https://www.yoursite.com" />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Contact Email">
          {getFieldDecorator('email', {
            rules: [
              {
                type: 'email',
                message: "That's not a valid email address",
              },
              required('Please enter an email address we can contact you at'),
            ],
          })(<Input style={{ width: '300px' }} name="email" />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Company Logo">
          {getFieldDecorator('logo', {
            rules: [
              required(
                "We'll need a logo to list your site. Please provide one" // `
              ),
            ],
          })(
            <Upload
              name="logo"
              onRemove={file => {
                this.setState({ logoFile: undefined })
              }}
              beforeUpload={file => {
                file.originFileObj = file
                this.setState({
                  logoFile: file,
                })
                return false
              }}
              fileList={this.state.logoFile ? [this.state.logoFile] : []}
              listType="picture"
              supportServerRender
            >
              <Button>
                <Icon type="upload" /> Click to Upload
              </Button>
            </Upload>
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Date Established">
          {getFieldDecorator('monthEstablished', {
            rules: [
              {
                required:
                  'Please enter the month and year the company was founded',
                validator: (rule, value, cb) => {
                  if (value && value.isAfter(Date.now())) {
                    return cb('Please enter a date in the past')
                  }

                  cb()
                },
              },
            ],
          })(<MonthPicker format="MM-YYYY" name="monthEstablished" />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Supported Currencies">
          {getFieldDecorator('currencies', {
            initialValue: [],
            rules: [required('Please pick at least one currency')],
          })(
            <CheckboxGroup
              onChange={currencies => {
                if (currencies.length > 0) {
                  const baseCurrency = getFieldValue('baseCurrency')
                  if (!baseCurrency) {
                    setFieldsValue({ baseCurrency: currencies[0] })
                    return
                  }
                }
                setFieldsValue({ currencies })
                validateFields(['baseCurrency'], { force: true })
              }}
              name="currencies"
              options={[
                { label: 'USD $', value: 'usd' },
                { label: 'EUR €', value: 'eur' },
                { label: 'GBP £', value: 'gbp' },
                { label: 'AUD $', value: 'aud' },
                { label: 'CAD $', value: 'cad' },
                { label: 'RUB ₽', value: 'rub' },
              ]}
            />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Default Currency"
          extra="NOTE: Prices in this form should be of this currency"
        >
          {getFieldDecorator('baseCurrency', {
            rules: [
              {
                required: 'Please pick your default currency',
                validator: (rule, value, cb) => {
                  const currs = getFieldValue('currencies')
                  if (!currs.some(c => c === value)) {
                    cb(
                      `Default currency must be one of your supported currencies${
                        currs.length > 0
                          ? ` (${currs.map(c => c.toUpperCase()).join(', ')})` // `
                          : ''
                      }`
                    )
                    return
                  }

                  cb()
                },
              },
            ],
          })(
            <RadioGroup name="baseCurrency">
              <RadioButton value="usd">USD $</RadioButton>
              <RadioButton value="eur">EUR €</RadioButton>
              <RadioButton value="gbp">GBP £</RadioButton>
              <RadioButton value="aud">AUD $</RadioButton>
              <RadioButton value="cad">CAD $</RadioButton>
              <RadioButton value="rub">RUB ₽</RadioButton>
            </RadioGroup>
          )}
        </FormItem>
        <FormItem style={displayNone}>
          {getFieldDecorator('keys', { initialValue: [popId] })(
            <input type="hidden" />
          )}
        </FormItem>
        {pointsOfPresence}
        <FormItem {...formItemLayout} label="Supported Platforms">
          {getFieldDecorator('platforms', {
            rules: [required('Please choose at least one platform')],
          })(
            <CheckboxGroup
              name="platforms"
              options={[
                { label: 'PC', value: 'pc' },
                { label: 'PS4', value: 'ps4' },
                { label: 'Xbox', value: 'xbox' },
              ]}
            />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Slots Per Server">
          {getFieldDecorator('slots[min]', { rules: [required('Required')] })(
            <InputNumber name="slots[min]" min={1} placeholder="Min" />
          )}
          {' - '}
          {getFieldDecorator('slots[max]', { rules: [required('Required')] })(
            <InputNumber name="slots[max]" min={1} placeholder="Max" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Price Per Slot"
          extra="If price per slot changes depending on configuration, put the cheapest price in minimum, and most expensive in maximum. If it's constant, put the same amount in both."
        >
          {getFieldDecorator('price[min]', { rules: [required('Required')] })(
            <InputNumber name="price[min]" min={0.01} placeholder="Min" />
          )}
          {' - '}
          {getFieldDecorator('price[max]', { rules: [required('Required')] })(
            <InputNumber name="price[max]" min={0.01} placeholder="Max" />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Control Panel Type">
          {getFieldDecorator('controlPanelType', {
            rules: [
              required('Please enter what kind of control panel you provide'),
            ],
          })(
            <Input
              name="controlPanelType"
              placeholder="TCAdmin? Custom Built? Something Else?"
            />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Control Panel Screenshots"
          extra="Please provider at least 2 screenshots"
        >
          {getFieldDecorator('controlPanelScreenshots[]', {
            rules: [required('Please provide a couple of screenshots')],
          })(
            <Upload
              name="controlPanelScreenshots[]"
              onRemove={file => {
                this.setState(({ screenshots }) => {
                  const index = screenshots.indexOf(file)
                  const newScreenshots = screenshots.slice()
                  newScreenshots.splice(index, 1)
                  return {
                    screenshots: newScreenshots,
                  }
                })
              }}
              beforeUpload={file => {
                file.originFileObj = file

                if (this.state.screenshots.length >= 6) {
                  this.state.screenshots.shift()
                }

                this.setState(({ screenshots }) => ({
                  screenshots: [...screenshots, file],
                }))
                return false
              }}
              fileList={this.state.screenshots}
              multiple
              listType="picture"
              supportServerRender
            >
              <Button>
                <Icon type="upload" /> Click to upload
              </Button>
            </Upload>
          )}
        </FormItem>

        <FormItem {...formItemLayout} label="DDOS Protection">
          {getFieldDecorator('ddos', {
            initialValue: { available: false, price: 0 },
          })(<CheckValueInput name="ddos" />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Mod Support">
          {getFieldDecorator('mods', {
            initialValue: { available: false, price: 0 },
          })(<CheckValueInput name="mods" />)}
        </FormItem>

        <FormItem {...formItemLayout} label="Mod Features">
          {getFieldDecorator('modsFeatures', {
            initialValue: `Do you have a mod manager GUI?
Are mods 1-click install or ini editing?
Do installed mods update automatically?
Anything else you want to share?`, // `
          })(<TextArea name="modFeatures" rows={5} maxLength={500} />)}
        </FormItem>
        <FormItem {...formItemLayout} label="Customer Support">
          {getFieldDecorator('customerSupport', { initialValue: [] })(
            <CheckboxGroup
              name="customerSupport"
              options={[
                { label: 'Email Support', value: 'email' },
                { label: 'Ticket System', value: 'ticket' },
                { label: 'Live Chat', value: 'chat' },
                { label: '24/7 Support', value: 'is247' },
              ]}
            />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label=" " colon={false}>
          {getFieldDecorator('customerSupportFeatures')(
            <TextArea
              name="customerSupportFeatures"
              placeholder="Anything else you want to add about customer support?"
              autosize={{ minRows: 1, maxRows: 3 }}
              maxLength={500}
            />
          )}
        </FormItem>

        <FormItem {...formItemLayout} label="Money Back Guarantee">
          {/* <Col span={4}> */}
          {getFieldDecorator('moneyBack[time]')(
            <InputNumber name="moneyBack[time]" min={1} />
          )}
          {/* </Col> */}
          {/* <Col span={6}> */}
          {getFieldDecorator('moneyBack[unit]', { initialValue: 'd' })(
            <StSelect
              style={{
                display: 'inline-block',
                width: 90,
                marginLeft: 15,
              }}
              name="moneyBack[unit]"
              onInputKeyDown={e => e.key === 'Enter' && e.preventDefault()}
            >
              <StOption key="h">Hours</StOption>
              <StOption key="d">Days</StOption>
            </StSelect>
          )}
          {/* </Col> */}
        </FormItem>
        <FormItem {...formItemLayout} label="Location Switching">
          {getFieldDecorator('locationSwitching', {
            initialValue: { available: false, price: 0 },
          })(<CheckValueInput name="locationSwitching" />)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Debranding Cost"
          extra="Leave at 0 if it's free"
        >
          {getFieldDecorator('debranding', {
            initialValue: 0,
          })(<InputNumber name="debranding" min={0} />)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Automatic Backups"
          extra="Is there an automatic backup mechanism for your servers? or is it the clients responsibility?"
        >
          {getFieldDecorator('automaticBackups', { initialValue: false })(
            <Switch name="automaticBackups" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Automatic Updates"
          extra="Is there an auto server update mechanism or do you manually roll them out?"
        >
          {getFieldDecorator('automaticUpdates', { initialValue: false })(
            <Switch name="automaticUpdates" />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Promo Codes"
          extra="Would you be willing to give the visitors of this site special discount codes?"
        >
          {getFieldDecorator('promoCodes', { initialValue: false })(
            <Switch name="promoCodes" />
          )}
        </FormItem>
        <FormItem {...formItemLayout} label="Notes">
          {getFieldDecorator('notes')(
            <TextArea
              name="notes"
              placeholder="Anything else you think is worth mentioning?"
              autosize={{ minRows: 4, maxRows: 8 }}
              maxLength={1000}
              placeholder="Anything else worth mentioning? Official Partner? Free Trial? Special Offers?"
            />
          )}
        </FormItem>

        {this.state.submitResult === true ? (
          <h3 style={{ textAlign: 'center' }}>
            Thank You! We'll be in touch shortly.
          </h3>
        ) : (
          <Form.Item wrapperCol={{ sm: { offset: 8 } }}>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              disabled={
                this.state.submitResult === false || hasErrors(getFieldsError())
              }
            >
              {this.state.submitResult === false ? (
                <Fragment>
                  <Icon type="loading" style={{ marginRight: '10px' }} />
                  Sending...
                </Fragment>
              ) : (
                'Send'
              )}
            </Button>
            {this.submitResult === false ? (
              ''
            ) : (
              <h3>{this.state.submitResult}</h3>
            )}
          </Form.Item>
        )}
      </StForm>
    )
  }
}

// const AddCompanyFormWrapper = Form.create()(AddCompanyForm)

function urlEncode(element, key, list = []) {
  if (typeof element === 'object') {
    Object.keys(element).forEach(k =>
      urlEncode(element[k], key ? `${key}[${k}]` : k, list)
    )
  } else {
    list.push(`${key}=${encodeURIComponent(element)}`)
  }
  return list.join('&')
}

const StRow = styled(Row)`
  padding: 20px 0 30px;
`
class AddCompany extends Component {
  state = {}

  constructor(props) {
    super(props)

    this._form = React.createRef()
    this._serializers = getSerializers(props.siteData)
  }

  _handleSubmit = async ({ error, values, callback = () => {} }) => {
    if (error) {
      console.error(error)
      callback({ submitResult: error })
      return
    }

    console.log('Received values of form: ', values)
    callback({ submitResult: false })

    const formData = toNetlifyFormData(values)

    // for (const x of formData.entries()) console.log(x)

    if (values.notes === '?-') return

    try {
      const response = await axios({
        method: 'post',
        url: '/',
        data: formData,
        config: {
          headers: { 'Content-Type': 'multipart/form-data; charset="utf-8"' },
        },
      })

      if (response.status !== 200) {
        throw new Error(`${response.status}: ${response.statusText}`) // `
      }

      callback({ submitResult: true })
    } catch (error) {
      console.error(error)
      callback({ submitResult: error.message })
    }
  }

  render() {
    const {
      siteData: {
        site,
        textBlocks: { addcompany },
      },
    } = this.props

    return (
      <Fragment>
        <Head>
          <title>
            Add {site.game.shortName} Server Host to {site.name}
          </title>
          <meta
            name="description"
            content={`${site.name} features the top ${
              site.game.name
            } server hosting companies in the world. If you think there's a ${
              site.game.shortName
            } hosting provider that should be on our list, send us the details and we'll take care of the rest`}
          />
        </Head>
        <Seperator />
        <StRow type="flex" align="middle" justify="center">
          <Col xs={22} sm={20} md={20} xl={15}>
            <BlockContent
              blocks={addcompany.body}
              serializers={this._serializers}
            />
            {/* hidden netlify form */}
            <form
              name="addCompany"
              style={{
                height: 0,
                width: 0,
                left: -10000,
                top: -10000,
                position: 'absolute',
                overflow: 'hidden',
              }}
              data-netlify="true"
              data-netlify-honeypot="hp"
            >
              <input type="hidden" name="hp" />
              <input type="hidden" name="form-name" value="addCompany" />
              <input type="text" name="companyName" />
              <input type="url" name="homepageUrl" />
              <input type="email" name="email" />
              <input type="file" name="logo" />
              <input type="month" name="monthEstablished" />
              <input type="text" name="currencies[]" />
              <input type="text" name="baseCurrency" />
              <input type="text" name="locations[]" />
              <input type="text" name="platforms[]" />
              <input type="number" name="slots[]" />
              <input type="number" name="price[]" />
              <input type="text" name="controlPanelType" />
              <input type="file" name="controlPanelScreenshot1" />
              <input type="file" name="controlPanelScreenshot2" />
              <input type="file" name="controlPanelScreenshot3" />
              <input type="file" name="controlPanelScreenshot4" />
              <input type="file" name="controlPanelScreenshot5" />
              <input type="file" name="controlPanelScreenshot6" />
              <input type="text" name="ddos[]" />
              <input type="text" name="mods[]" />
              <input type="text" name="modsFeatures" />
              <input type="text" name="customerSupport[]" />
              <input type="text" name="customerSupportFeatures" />
              <input type="text" name="moneyBack[]" />
              <input type="text" name="locationSwitching[]" />
              <input type="number" name="debranding" />
              <input type="checkbox" name="automaticBackups" />
              <input type="checkbox" name="automaticUpdates" />
              <input type="checkbox" name="promoCodes" />
              <input type="text" name="notes" />
            </form>
            {/*             <Fragment>
              <AddCompanyFormWrapper
                ref={this._form}
                onSubmit={this._handleSubmit}
              />
            </Fragment> */}
          </Col>
        </StRow>
        <Seperator />
      </Fragment>
    )
  }
}

export default withSiteData(AddCompany)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/AddCompany.jsx